import React from 'react'
import MiniItem from './miniItem'
import P1 from '../../../images/sellerpolicies/1.png'
import P2 from '../../../images/sellerpolicies/2.png'
import P3 from '../../../images/sellerpolicies/3.png'
import P4 from '../../../images/sellerpolicies/4.png'
import P5 from '../../../images/sellerpolicies/5.png'
import P6 from '../../../images/sellerpolicies/6.png'
import P7 from '../../../images/sellerpolicies/7.png'
import P8 from '../../../images/sellerpolicies/8.png'
import P9 from '../../../images/sellerpolicies/9.png'
import P10 from '../../../images/sellerpolicies/10.png'
import P11 from '../../../images/sellerpolicies/11.png'
import P12 from '../../../images/sellerpolicies/12.png'
import P13 from '../../../images/sellerpolicies/13.png'
import P14 from '../../../images/sellerpolicies/14.png'
import P15 from '../../../images/sellerpolicies/15.png'
import P16 from '../../../images/sellerpolicies/16.png'
import P17 from '../../../images/sellerpolicies/17.png'
import P18 from '../../../images/sellerpolicies/18.png'
import P19 from '../../../images/sellerpolicies/19.png'
import P20 from '../../../images/sellerpolicies/20.png'
import P21 from '../../../images/sellerpolicies/21.png'
import P22 from '../../../images/sellerpolicies/22.png'
import P23 from '../../../images/sellerpolicies/23.png'


import B1 from '../../../images/buyerpolicies/Amendments.png'
import B2 from '../../../images/buyerpolicies/Contact.png'
import B3 from '../../../images/buyerpolicies/Copyright.png'
import B4 from '../../../images/buyerpolicies/Delivery And Cancellations.png'
import B5 from '../../../images/buyerpolicies/Exchange Policy.png'
import B6 from '../../../images/buyerpolicies/Intellectual Property Rights.png'
import B7 from '../../../images/buyerpolicies/KAAY Closet.png'
import B8 from '../../../images/buyerpolicies/Our Contract.png'
import B9 from '../../../images/buyerpolicies/Payment.png'
import B10 from '../../../images/buyerpolicies/Personal Information.png'
import B11 from '../../../images/buyerpolicies/Pricing and Availability.png'
import B12 from '../../../images/buyerpolicies/Privacy Policy.png'
import B13 from '../../../images/buyerpolicies/Product.png'
import B14 from '../../../images/buyerpolicies/Retention Of Title.png'
import B15 from '../../../images/buyerpolicies/Scam.png'
import B16 from '../../../images/buyerpolicies/Termination.png'
import B17 from '../../../images/buyerpolicies/User Content.png'


const Index = () => {
  return (
    <div className='sellerpolicies_wrapper'>
        <h3>Seller Policies</h3>
        <div className='sellerpolicies_container'>
            <MiniItem Name={'Account Suspension & Penalties'} Image={P1} Policiy={'account_suspension_penalties'} />
            <MiniItem Name={'Advertisements on the Service'} Image={P2} Policiy={'advertisements_on_the_service'} />
            <MiniItem Name={'COMMISSION Structure'} Image={P3} Policiy={'commission_structure'} />
            <MiniItem Name={'Conflict Resolution'} Image={P4} Policiy={'conflict_resolution'} />
            <MiniItem Name={'DATA COLLECTION FROM SELLER'} Image={P5} Policiy={'data_collection_from_seller'} />
            <MiniItem Name={'Discount Policy'} Image={P6} Policiy={'discount_policy'} />
            <MiniItem Name={'INDEMNIFICATION'} Image={P7} Policiy={'indemnification'} />
            <MiniItem Name={'INTELLECTUAL PROPERTY'} Image={P8} Policiy={'intellectual_property'} />
            <MiniItem Name={'Misleading Information'} Image={P9} Policiy={'misleading_information'} />
            <MiniItem Name={'SELLER OBLIGATIONS TO CUSTOMER SERVICE'} Image={P10} Policiy={'seller_obligations_to_customer_service'} />
            <MiniItem Name={'Packaging guidelines'} Image={P11} Policiy={'packaging_guidelines'} />
            <MiniItem Name={'Parcel / Order lost'} Image={P12} Policiy={'parcel_order_lost'} />
            <MiniItem Name={'PAYMENT Policy'} Image={P13} Policiy={'payment_policy'} />
            <MiniItem Name={'PR Gifting'} Image={P14} Policiy={'pr_gifting'} />
            <MiniItem Name={'Your Product Listings/Featuring'} Image={P15} Policiy={'your_product_listings_featuring'} />
            <MiniItem Name={'Requirments for Registration'} Image={P16} Policiy={'requirments_for_registration'} />
            <MiniItem Name={'RETURN AND REPLACEMENT'} Image={P17} Policiy={'return_and_replacement'} />
            <MiniItem Name={'Seller information'} Image={P18} Policiy={'seller_information'} />
            <MiniItem Name={'Seller Performance'} Image={P19} Policiy={'seller_performance'} />
            <MiniItem Name={'Shipping and Order Fulfilment'} Image={P20} Policiy={'shipping_and_order_fulfilment'} />
            <MiniItem Name={'SHIPPING'} Image={P21} Policiy={'shipping'} />
            <MiniItem Name={'Taxes'} Image={P22} Policiy={'taxes'} />
            <MiniItem Name={'TERMINATION & DURATION '} Image={P23} Policiy={'termination_and_duration'} />
        </div>
        <h3>Buyer Policies</h3>
        <div className='sellerpolicies_container'>
            <MiniItem Name={'Amendments'} Image={B1} Policiy={'amendments'} />
            <MiniItem Name={'Contact'} Image={B2} Policiy={'contact'} />
            <MiniItem Name={'Copyright'} Image={B3} Policiy={'copyright'} />
            <MiniItem Name={'Delivery And Cancellations'} Image={B4} Policiy={'delivery_and_cancellations'} />
            <MiniItem Name={'Exchange Policy'} Image={B5} Policiy={'exchange_policy'} />
            <MiniItem Name={'Intellectual Property Rights'} Image={B6} Policiy={'intellectual_property_rights'} />
            <MiniItem Name={'KAAY Closet'} Image={B7} Policiy={'kaay_closet'} />
            <MiniItem Name={'Our Contract'} Image={B8} Policiy={'our_contract'} />
            <MiniItem Name={'Payment'} Image={B9} Policiy={'payment'} />
            <MiniItem Name={'Personal Information'} Image={B10} Policiy={'personal_information'} />
            <MiniItem Name={'Pricing and Availability'} Image={B11} Policiy={'pricing_and_availability'} />
            <MiniItem Name={'Privacy Policy'} Image={B12} Policiy={'privacy_policy'} />
            <MiniItem Name={'Product'} Image={B13} Policiy={'product'} />
            <MiniItem Name={'Retention Of Title'} Image={B14} Policiy={'retention_of_title'} />
            <MiniItem Name={'Scam'} Image={B15} Policiy={'scam'} />
            <MiniItem Name={'Termination'} Image={B16} Policiy={'termination'} />
            <MiniItem Name={'User Content'} Image={B17} Policiy={'user_content'} />
        </div>
    </div>
  )
}

export default Index
